// pepper working hours (from 9am to 9pm)
const minHourNumeric = 9;
const maxHourNumeric = 21;

// Conversión para obtener la fecha local correctamente sin desfase horario
export const getLocalDateString = (date: Date, lineSeparator: boolean = true): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return lineSeparator ?`${year}-${month}-${day}` : `${year}${month}${day}`;
};

// Día actual con y sin formato ISO
// export const todayDate = new Date(); // Cambia la fecha según sea necesario
export const todayDateFormatted = getLocalDateString(new Date());

// Formato de fecha dd/mm/yyyy
export const dateFormatStandard = (date: Date, shortYear?: boolean): string => {
  return date.toLocaleDateString('es-ES', {
    year: shortYear ? '2-digit' : 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export const validTimeHelper = (timeString: string) => {
  const timeArray = timeString.split(':');
  const isValid =
    parseInt(timeArray[0]) >= minHourNumeric &&
    parseInt(timeArray[0]) <= maxHourNumeric;
  return isValid;
};

export const validDateHelper = (dateData: string) => {
  return dateData >= todayDateFormatted;
};
export const formatDate = (dateString: string): string => {
  const today = new Date(todayDateFormatted);
  const date = new Date(dateString);
  if (date.toDateString() === today.toDateString()) {
    return 'Hoy';
  }
  return dateFormatStandard(date);
};

export const addMonthsToDate = (date: Date, months: number): Date => {
  const newDate = date;
  newDate.setMonth(newDate.getMonth() + months);

  return newDate;
};

export const getNextDateWithMonthDay = (monthDay: number): Date => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  // Se calcula el siguiente mes a partir del día actual
  return new Date(currentYear, currentMonth, monthDay);
};

export const getTodayDayOfMonth = (): number => {
  return new Date().getDate();
};

export const getNewDate = (
  date: Date,
  monthDay: number,
  rowNumber?: number
): Date => {
  let newDate = date;
  rowNumber ??= 1; // Si no se recibe por defecto se asigna 1

  // Si el último día del mes no coincide con el del mes actual, se ajusta al último día del mes correcto
  const lastDate = new Date(date.getFullYear(), date.getMonth(), 0);
  if (monthDay !== date.getDate() && monthDay >= 29) {
    newDate = rowNumber === 0 ? new Date() : lastDate;
  }
  return newDate;
};

// Devuelve el último día del mes con la fecha que correspondaxs
export const getLastDayOfMonth = (dateValue?: Date): number => {
  const date = dateValue || new Date();
  const lastDayOfMonth = new Date(
    date.getFullYear(),
    date.getMonth() + 2,
    0
  ).getDate();
  return lastDayOfMonth;
};
